import { arrayOf, number, shape, string } from "prop-types";
import { unitShape } from "./unit.js";

export const floorPlanShape = shape({
  area: number.isRequired,
  bedrooms: string.isRequired,
  bathrooms: string.isRequired,
  floorPlan: string,
  id: string.isRequired,
  image: string,
  matterportId: string,
  sightmapEmbed: string,
  startingAt: string.isRequired,
  units: arrayOf(unitShape),
  unitsAvailable: number,
  url: string,
});
